import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useEffect, useRef, useState } from 'react';
import { FaUserCircle } from 'react-icons/fa';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { MdTaskAlt } from 'react-icons/md';
const TaskContent = ({ item }) => {
  const {
    fields: { summary, assignee, status },
    key,
  } = item;
  const [taskStatus, setStoryStatus] = useState(status.name);
  const [showStatusOptions, setShowStatusOptions] = useState(false);
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  const hanldeStatusChange = (status) => {
    setStoryStatus(status);
    setShowStatusOptions(false);
  };
  const statusRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (statusRef.current && !statusRef.current.contains(event.target)) {
        setShowStatusOptions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <div
      className="flex w-full flex-col gap-3 border border-zinc-700 bg-zinc-900 px-2 text-gray-50 transition duration-100  hover:bg-zinc-800"
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      style={style}
    >
      <div
        className={`flex w-full items-center justify-between py-1.5 transition duration-100 hover:text-white`}
      >
        <div className="flex items-center gap-3">
          <span className="rounded-md bg-blue-600 p-1">
            <MdTaskAlt className="text-white" size={12} />
          </span>
          <span className="text-base font-semibold">{key}</span>
          <div ref={statusRef} className="mr-3">
            <button
              className={`relative flex items-center justify-center gap-1 rounded-3xl border border-black px-2 py-0.5 text-[12px] uppercase ${
                taskStatus === 'To Do' ? 'bg-[#5652CF]' : 'bg-yellow-500'
              }`}
              onClick={() => setShowStatusOptions((prev) => !prev)}
            >
              <span className="mt-1">{taskStatus}</span>
              <MdKeyboardArrowDown size={15} className="font-semibold" />
            </button>
            {showStatusOptions && (
              <div
                className={`absolute ${
                  showStatusOptions ? 'flex' : 'hidden'
                } z-50 flex-col items-center justify-center gap-2 rounded-lg bg-[#1d1d1f] p-2 text-gray-50`}
              >
                {/* eslint-disable-next-line */}
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    hanldeStatusChange('In Progress');
                  }}
                  className="cursor-pointer text-nowrap p-1 text-sm font-semibold hover:text-white"
                >
                  In Progress
                </span>
                {/* eslint-disable-next-line */}
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    hanldeStatusChange('To Do');
                  }}
                  className="cursor-pointer text-nowrap p-1 text-sm font-semibold hover:text-white"
                >
                  To Do
                </span>
              </div>
            )}
          </div>
          <p className=" text-base font-semibold">{summary}</p>
        </div>
        <div className="flex items-center gap-4">
          {assignee?.displayName && (
            <span className="inline-flex items-center justify-center gap-2 rounded-3xl border border-zinc-600 bg-zinc-950 px-1.5 py-1 text-sm">
              <FaUserCircle />
              {assignee?.displayName}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default TaskContent;
